// Auth Constants
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_PROFILE_PIC_ACCESS_TOKEN = 'SET_PROFILE_PIC_ACCESS_TOKEN';

// User Constants
export const USERS_LOADING = 'USERS_LOADING';
export const USERS_SUCCESS = 'USERS_SUCCESS';
export const USERS_FAILURE = 'USERS_FAILURE';
export const ME_LOADING = 'ME_LOADING';
export const ME_SUCCESS = 'ME_SUCCESS';
export const ME_FAILURE = 'ME_FAILURE';
export const JOINING_TEAM = 'JOINING_TEAM';
export const JOIN_TEAM_SUCCESS = 'JOIN_TEAM_SUCCESS';
export const JOIN_TEAM_FAILURE = 'JOIN_TEAM_FAILURE';
export const AWARDS_LOADING = 'AWARDS_LOADING';
export const AWARDS_LOADING_SUCCESS = 'AWARDS_LOADING_SUCCESS';
export const AWARDS_LOADING_FAILURE = 'AWARDS_LOADING_FAILURE';
export const LEAVING_TEAM = 'LEAVING_TEAM';
export const LEAVE_TEAM_SUCCESS = 'LEAVE_TEAM_SUCCESS';
export const LEAVE_TEAM_FAILURE = 'LEAVE_TEAM_FAILURE';
export const UPDATE_SELECTED_TEAM = 'UPDATE_SELECTED_TEAM';
export const TOGGLING_FAVORITE_TEAM = 'TOGGLING_FAVORITE_TEAM';
export const TOGGLING_FAVORITE_TEAM_SUCCESS = 'TOGGLING_FAVORITE_TEAM_SUCCESS';
export const TOGGLING_FAVORITE_TEAM_FAILURE = 'TOGGLING_FAVORITE_TEAM_FAILURE';
export const NEW_TEAM_VISITED = 'NEW_TEAM_VISITED';
export const USERS_UPDATING = 'USERS_UPDATING';
export const USERS_UPDATING_SUCCESS = 'USERS_UPDATING_SUCCESS';
export const USERS_UPDATING_FAILURE = 'USERS_UPDATING_FAILURE';
export const RESET_USERS_UPDATING_SUCCESS = 'RESET_USERS_UPDATING_SUCCESS';
export const USERS_DELETING = 'USERS_DELETING';
export const USERS_DELETING_SUCCESS = 'USERS_DELETING_SUCCESS';
export const USERS_DELETING_FAILURE = 'USERS_DELETING_FAILURE';
export const RESET_USERS_DELETING_SUCCESS = 'RESET_USERS_DELETING_SUCCESS';
export const SENDING_FEEDBACK = 'SENDING_FEEDBACK';
export const SEND_FEEDBACK_SUCCESS = 'SEND_FEEDBACK_SUCCESS';
export const SEND_FEEDBACK_FAILURE = 'SEND_FEEDBACK_FAILURE';
export const RESET_SEND_FEEDBACK_SUCCESS = 'RESET_SEND_FEEDBACK_SUCCESS';
export const ACCEPTING_EULA = 'ACCEPTING_EULA';
export const ACCEPT_EULA_SUCCESS = 'ACCEPT_EULA_SUCCESS';
export const ACCEPT_EULA_FAILURE = 'ACCEPT_EULA_FAILURE';
export const RESET_ACCEPT_EULA_SUCCESS = 'RESET_ACCEPT_EULA_SUCCESS';

export const TOGGLE_PERSONAL_NOTIFICATIONS = 'TOGGLE_PERSONAL_NOTIFICATIONS';
export const TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS = 'TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS';
export const TOGGLE_PERSONAL_NOTIFICATIONS_FAILURE = 'TOGGLE_PERSONAL_NOTIFICATIONS_FAILURE';
export const RESET_TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS = 'RESET_TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS';

export const TOGGLE_ALL_NOTIFICATIONS = 'TOGGLE_ALL_NOTIFICATIONS';
export const TOGGLE_ALL_NOTIFICATIONS_SUCCESS = 'TOGGLE_ALL_NOTIFICATIONS_SUCCESS';
export const TOGGLE_ALL_NOTIFICATIONS_FAILURE = 'TOGGLE_ALL_NOTIFICATIONS_FAILURE';
export const RESET_TOGGLE_ALL_NOTIFICATIONS_SUCCESS = 'RESET_TOGGLE_ALL_NOTIFICATIONS_SUCCESS';

export const TOUR_SAVING = 'TOUR_SAVING';
export const TOUR_SUCCESS = 'TOUR_SUCCESS';
export const TOUR_FAILURE = 'TOUR_FAILURE';
export const RESET_TOUR_SUCCESS = 'RESET_TOUR_SUCCESS';

export const DELETING_TOURS = 'DELETING_TOURS';
export const DELETE_TOURS_SUCCESS = 'DELETE_TOURS_SUCCESS';
export const DELETE_TOURS_FAILURE = 'DELETE_TOURS_FAILURE';
export const RESET_DELETE_TOURS_SUCCESS = 'RESET_DELETE_TOURS_SUCCESS';

// Team Constants
export const TEAMS_LOADING = 'TEAMS_LOADING';
export const TEAMS_SUCCESS = 'TEAMS_SUCCESS';
export const TEAMS_FAILURE = 'TEAMS_FAILURE';
export const POST_LOADING = 'POST_LOADING';
export const POST_SUCCESS = 'POST_SUCCESS';
export const POST_FAILURE = 'POST_FAILURE';
export const POSTS_LOADING = 'POSTS_LOADING';
export const POSTS_SUCCESS = 'POSTS_SUCCESS';
export const POSTS_FAILURE = 'POSTS_FAILURE';
export const PAGINATED_POSTS_LOADING = 'PAGINATED_POSTS_LOADING';
export const PAGINATED_POSTS_SUCCESS = 'PAGINATED_POSTS_SUCCESS';
export const PAGINATED_POSTS_FAILURE = 'PAGINATED_POSTS_FAILURE';
export const SUBPOSTS_LOADING = 'SUBPOSTS_LOADING';
export const SUBPOSTS_SUCCESS = 'SUBPOSTS_SUCCESS';
export const SUBPOSTS_FAILURE = 'SUBPOSTS_FAILURE';
export const CREATE_TEAM = 'CREATE_TEAM';
export const CREATE_TEAM_SUCCESS = 'CREATE_TEAM_SUCCESS';
export const CREATE_TEAM_FAILURE = 'CREATE_TEAM_FAILURE';
export const RESET_SEND_TOKENS_SUCCESS = 'RESET_SEND_TOKENS_SUCCESS';
export const SENDING_TOKENS = 'SENDING_TOKENS';
export const SEND_TOKENS_SUCCESS = 'SEND_TOKENS_SUCCESS';
export const SEND_TOKENS_FAILURE = 'SEND_TOKENS_FAILURE';
export const SENDING_SUBPOST_TOKENS = 'SENDING_SUBPOST_TOKENS';
export const SEND_SUBPOST_TOKENS_SUCCESS = 'SEND_SUBPOST_TOKENS_SUCCESS';
export const SEND_SUBPOST_TOKENS_FAILURE = 'SEND_SUBPOST_TOKENS_FAILURE';
export const LIKE_POST = 'LIKE_POST';
export const LIKE_POST_SUCCESS = 'LIKE_POST_SUCCESS';
export const LIKE_POST_FAILURE = 'LIKE_POST_FAILURE';
export const LIKE_SUBPOST = 'LIKE_SUBPOST';
export const LIKE_SUBPOST_SUCCESS = 'LIKE_SUBPOST_SUCCESS';
export const LIKE_SUBPOST_FAILURE = 'LIKE_SUBPOST_FAILURE';
export const ADD_TEAM_MEMBERS = 'ADD_TEAM_MEMBERS';
export const ADD_TEAM_MEMBERS_SUCCESS = 'ADD_TEAM_MEMBERS_SUCCESS';
export const ADD_TEAM_MEMBERS_FAILURE = 'ADD_TEAM_MEMBERS_FAILURE';
export const RESET_ADD_TEAM_MEMBERS_COMPLETE = 'RESET_ADD_TEAM_MEMBERS_COMPLETE';
export const EDIT_TEAM = 'EDIT_TEAM';
export const EDIT_TEAM_SUCCESS = 'EDIT_TEAM_SUCCESS';
export const EDIT_TEAM_FAILURE = 'EDIT_TEAM_FAILURE';
export const DELETE_TEAM = 'DELETE_TEAM';
export const DELETE_TEAM_SUCCESS = 'DELETE_TEAM_SUCCESS';
export const DELETE_TEAM_FAILURE = 'DELETE_TEAM_FAILURE';
export const RESET_DELETE_TEAM_SUCCESS = 'RESET_DELETE_TEAM_SUCCESS';
export const RESET_CREATE_TEAM_SUCCESS = 'RESET_CREATE_TEAM_SUCCESS';
export const RESET_EDIT_TEAM_SUCCESS = 'RESET_EDIT_TEAM_SUCCESS';

export const START_SEASON = 'START_SEASON';
export const START_SEASON_SUCCESS = 'START_SEASON_SUCCESS';
export const START_SEASON_FAILURE = 'START_SEASON_FAILURE';
export const RESET_START_SEASON_SUCCESS = 'RESET_START_SEASON_SUCCESS';

export const END_SEASON = 'END_SEASON';
export const END_SEASON_SUCCESS = 'END_SEASON_SUCCESS';
export const END_SEASON_FAILURE = 'END_SEASON_FAILURE';
export const RESET_END_SEASON_SUCCESS = 'RESET_END_SEASON_SUCCESS';

export const UPDATE_SEASON = 'UPDATE_SEASON';
export const UPDATE_SEASON_SUCCESS = 'UPDATE_SEASON_SUCCESS';
export const UPDATE_SEASON_FAILURE = 'UPDATE_SEASON_FAILURE';
export const RESET_UPDATE_SEASON_SUCCESS = 'RESET_UPDATE_SEASON_SUCCESS';

export const TEAM_SEASONS_LOADING = 'TEAM_SEASONS_LOADING';
export const TEAM_SEASONS_SUCCESS = 'TEAM_SEASONS_SUCCESS';
export const TEAM_SEASONS_FAILURE = 'TEAM_SEASONS_FAILURE';

export const DELETING_POST = 'DELETING_POST';
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS';
export const DELETE_POST_FAILURE = 'DELETE_POST_FAILURE';
export const RESET_DELETE_POST_SUCCESS = 'RESET_DELETE_POST_SUCCESS';

export const DELETING_SUBPOST = 'DELETING_SUBPOST';
export const DELETE_SUBPOST_SUCCESS = 'DELETE_SUBPOST_SUCCESS';
export const DELETE_SUBPOST_FAILURE = 'DELETE_SUBPOST_FAILURE';
export const RESET_DELETE_SUBPOST_SUCCESS = 'RESET_DELETE_SUBPOST_SUCCESS';

export const TEAM_USER_STATS_LOADING = 'TEAM_USER_STATS_LOADING';
export const TEAM_USER_STATS_SUCCESS = 'TEAM_USER_STATS_SUCCESS';
export const TEAM_USER_STATS_FAILURE = 'TEAM_USER_STATS_FAILURE';

export const SENDING_SHOUT_OUT = 'SENDING_SHOUT_OUT';
export const SENDING_SHOUT_OUT_SUCCESS = 'SENDING_SHOUT_OUT_SUCCESS';
export const SENDING_SHOUT_OUT_FAILURE = 'SENDING_SHOUT_OUT_FAILURE';
export const RESET_SENDING_SHOUT_OUT_SUCCESS = 'RESET_SENDING_SHOUT_OUT_SUCCESS';

// Team Badges
export const SEASON_BADGES_LOADING = 'SEASON_BADGES_LOADING';
export const SEASON_BADGES_SUCCESS = 'SEASON_BADGES_SUCCESS';
export const SEASON_BADGES_FAILURE = 'SEASON_BADGES_FAILURE';

// Tour Demo Constants

export const SETUP_SETTINGS_TOUR = 'SETUP_SETTINGS_TOUR';
export const CLEANUP_SETTINGS_TOUR = 'CLEANUP_SETTINGS_TOUR';
export const SETUP_TEAMHOME_TOUR = 'SETUP_TEAMHOME_TOUR';
export const CLEANUP_TEAMHOME_TOUR = 'CLEANUP_TEAMHOME_TOUR';

//Easter Eggs
export const EASTER_EGGS_LOADING = 'EASTER_EGGS_LOADING';
export const EASTER_EGGS_SUCCESS = 'EASTER_EGGS_SUCCESS';
export const EASTER_EGGS_FAILURE = 'EASTER_EGGS_FAILURE';
export const USER_EASTER_EGGS_LOADING = 'USER_EASTER_EGGS_LOADING';
export const USER_EASTER_EGGS_LOADING_SUCCESS = 'USER_EASTER_EGGS_LOADING_SUCCESS';
export const USER_EASTER_EGGS_LOADING_FAILURE = 'USER_EASTER_EGGS_LOADING_FAILURE';
export const POST_EASTER_EGG_FOUND_SUCCESS = 'POST_EASTER_EGG_FOUND_SUCCESS';
export const POST_EASTER_EGG_FOUND_FAILURE = 'POST_EASTER_EGG_FOUND_FAILURE';
export const AM_I_MASTER_EGG_HUNTER_SUCCESS = 'AM_I_MASTER_EGG_HUNTER_SUCCESS';
export const AM_I_MASTER_EGG_HUNTER_FAILURE = 'AM_I_MASTER_EGG_HUNTER_FAILURE';
export const MASTER_EGG_HUNTERS_LOADING = 'MASTER_EGG_HUNTERS_LOADING';
export const GET_MASTER_EGG_HUNTERS_SUCCESS = 'GET_MASTER_EGG_HUNTERS_SUCCESS';
export const GET_MASTER_EGG_HUNTERS_FAILURE = 'GET_MASTER_EGG_HUNTERS_FAILURE';
export const CLEAR_AM_I_MASTER_EGG_HUNTER = 'CLEAR_AM_I_MASTER_EGG_HUNTER';
